import PropTypes from "prop-types";
import { Progress } from "@cea/ui-kit";

import styles from "./unified-upload.module.css";

export const UploadNotificationContent = ({
  fileName,
  fileSize,
  progress,
  uploadFailed,
}) => (
  <>
    <div className={styles["notification-info-text"]}>
      <b>File: </b> {fileName}
    </div>
    <div className={styles["notification-info-text"]}>
      <b>Total size:</b> {fileSize}
    </div>
    <Progress percent={progress} status={uploadFailed ? "exception" : null} />
  </>
);

UploadNotificationContent.defaultProps = {
  fileName: null,
  fileSize: null,
  progress: 0,
  uploadFailed: false,
};

UploadNotificationContent.propTypes = {
  fileName: PropTypes.string,
  fileSize: PropTypes.string,
  progress: PropTypes.number,
  uploadFailed: PropTypes.bool,
};
